// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__D2xAs","result":"Search_result__BJ7dw","list":"Search_list__a1ELK","listItem":"Search_listItem__RHYp8","emptyResult":"Search_emptyResult__dEse_"};